/* 这里主要是猜你喜欢，推荐专栏的代码 */

import { HttpServer } from '@/services/server'
import { renderPopular } from '@/utils/tools'
import WKInfiniteScroll from '@/components/WKInfiniteScroll/WKInfiniteScroll'
import * as React from 'react'
import './HomeRecommendModule.style'
import { ExposureSPM } from '@/services/Modules/hotSpotServer'
import * as Styles from './RecommendModule.style'
import { ImageView } from '../ImageView/ImageView'
import { classes } from 'typestyle'
const LIMIT_NUM = 10
import { EventType } from '@/services/Modules/reportServer'
import { RegisterElement } from '@/services/hotspotReport'
import { ViewingMonitor, reAssemblyUbt } from '@weike/operation-report'
import { UbtElement } from '../../../../services/Modules/hotSpotServer'
import { reportSetUbt } from '../../../../services/Modules/reportServer'
import style from './index.module.less'

interface IState {
  recommends: ChannelRetType['contents']
  hasMore: boolean
  // offset: number
  loading: boolean
  apiError: boolean
  firstTime: boolean
  hasInitLocalData: boolean
  modelVersion: string
  page: number
  next_page: number
}

interface CommonRet {
  status: number
  statusText: string
  data: CommonRetData
}

interface CommonRetData {
  code: number
  msg: string
  data: ChannelRetType
}

interface IStorageType {
  channelList: InewChannelType[]
  hasMore: boolean
  // offset: number
  loading: boolean
  expireTime: number
}

interface ChannelRetType {
  contents: InewChannelType[]
  has_more: boolean
  model_version: string
  page: number
  limit: number
  next_page: number
}

interface InewChannelType {
  cover_url: string
  channel_id: number
  name: string
  lecture_money: number
  limit_money?: number
  popular: number
  expected_lectures: number
  has_limitmoney: boolean
  updated_lectures: number
  is_preffered: boolean
  next_page: number
}

export default class HomeRecommendModule extends React.Component<{}, IState> {
  public state = {
    recommends: [],
    hasMore: true,
    // offset: 0,
    page: 1,
    loading: false,
    apiError: false,
    firstTime: true,
    hasInitLocalData: false,
    modelVersion: '',
    next_page: 1
  }

  public componentDidMount() {
    this.init()
  }

  public async init() {
    const key = 'WEIKE-HOMEPAGE-RECOMMEND2-CHANNEL'
    const key2 = 'WEIKE-HOMEPAGE-RECOMMEND2-SCROLLPOSITION'
    const getRecChannnelFrStorage = window.sessionStorage.getItem(key)
    const getScrollTopFrStorage = window.sessionStorage.getItem(key2)
    const isASampleUser = await this.isFormSampleUser()
    if (getRecChannnelFrStorage && getScrollTopFrStorage && getScrollTopFrStorage !== '0' && isASampleUser) {
      const oldData: IStorageType = JSON.parse(window.sessionStorage.getItem(key) as string)
      if (oldData.expireTime < new Date().getTime()) {
        this.reCall()
        return
      }
      this.setState(
        {
          ...this.state,
          firstTime: false,
          ...oldData
        },
        () => {
          setTimeout(() => {
            window.scrollTo(0, parseInt(window.sessionStorage.getItem(key2) as string, 10))
          }, 250)
        }
      )
    } else {
      this.fetchRecommends()
    }

    setTimeout(() => {
      this.setState({
        hasInitLocalData: true
      })
    }, 260)
  }

  public reCall() {
    const key = 'WEIKE-HOMEPAGE-RECOMMEND2-CHANNEL'
    const key2 = 'WEIKE-HOMEPAGE-RECOMMEND2-SCROLLPOSITION'
    window.sessionStorage.removeItem(key)
    window.sessionStorage.removeItem(key2)
    window.scrollTo(0, 0)
    this.fetchRecommends()
  }

  public fetchRecommends = () => {
    this.setState({
      loading: true
    })
    HttpServer.getRecommendChannel({
      page: this.state.page,
      limit: LIMIT_NUM
    })
      .then((res: CommonRet) => {
        if (res.data.code === 0) {
          const { data } = res.data
          const { contents } = data
          const { page } = this.state
          const channelList1 = this.state.recommends.concat(contents)
          this.setState(
            {
              recommends: channelList1,
              loading: false,
              firstTime: false,
              hasMore: data.has_more,
              page: data.next_page,
              modelVersion: data.model_version
            },
            () => {
              this.saveDataToStorage()
            }
          )
        }
      })
      .catch(err => {
        this.setState({
          apiError: true
        })
      })
  }

  public scrollTopRecFn = (val: number) => {
    // 初始化数据后才允许滚动
    if (!this.state.hasInitLocalData) {
      return
    }
    const key = 'WEIKE-HOMEPAGE-RECOMMEND2-SCROLLPOSITION'
    window.sessionStorage.setItem(key, val.toString())
  }

  public async isFormSampleUser() {
    const userid = await this.getUserInfo()
    const key = 'WEIKE-HOMEPAGE-RECOMMEND2-CHANNEL-USER'
    const getUserIdFrStorage = window.sessionStorage.getItem(key)
    if (getUserIdFrStorage && getUserIdFrStorage.length > 0) {
      return parseInt(getUserIdFrStorage, 10) === userid
    } else {
      window.sessionStorage.setItem(key, userid.toString())
      return false
    }
  }

  public getUserInfo(): Promise<number> {
    return new Promise((resolve, reject) => {
      const timer = setInterval(() => {
        const Session = (window as any).Session
        if (Session) {
          clearInterval(timer)
          Session.getToken((res: any) => {
            const account = res
            const userID = account.id
            resolve(userID)
          })
        }
      }, 30)
    })
  }

  public saveDataToStorage() {
    const key = 'WEIKE-HOMEPAGE-RECOMMEND2-CHANNEL'
    const cacheTime = 1000 * 60 * 10 // 10分钟
    const expireTime = new Date().getTime() + cacheTime
    const data = {
      expireTime,
      page: this.state.page,
      recommends: this.state.recommends,
      hasMore: this.state.hasMore,
      loading: this.state.loading,
      modelVersion: this.state.modelVersion
    }
    const saveData = JSON.stringify(data)
    window.sessionStorage.setItem(key, saveData)
  }

  public render() {
    const { loading, hasMore, modelVersion, page } = this.state
    return (
      <div>
        <div className="psFollowLike" style={{ background: '#fff' }}>
          {this.state.recommends.length > 0 && <h3 className="psLikeTitle">更多推荐</h3>}
          <div className={Styles.MoreWonderfulModule}>
            {this.state.recommends &&
              this.state.recommends.map((item: InewChannelType, index) => {
                if (!item) {
                  return null
                }
                // todo: 特例，不推荐卢文建的课程
                if (item.channel_id === 320857) {
                  return <></>
                }
                return <RecommendItem key={index} modelVersion={modelVersion} item={item} page={page} index={index} />
              })}
          </div>
        </div>
        <WKInfiniteScroll
          onTouchBottom={this.fetchRecommends} // 到达底部执行的方法
          isStop={loading} // 暂停执行onTouchBottom，一般是正在请求接口时触发
          distance={200} // 距离底部多少px触发
          isKill={!hasMore || this.state.apiError}
          isShowLoading={loading}
          scrollTopRec={this.scrollTopRecFn}
        />
      </div>
    )
  }
}

const RecommendItem = ({ item, modelVersion, page, index }) => {
  const inviterId = 61221610
  const items: InewChannelType = item
  const ubt = reAssemblyUbt(`${RegisterElement.rec_list_x}`)
  const getUbt = reportSetUbt(UbtElement)

  const goUrl = () => {
    const link = `/channel2/${items.channel_id}?inviter_id=${inviterId}`
    const model = modelVersion ? `&model=${modelVersion}` : ''
    try {
      HttpServer.reportServerAPI([
        {
          ubt: getUbt.split('=')[1],
          evt: EventType.click,
          evt_params: {
            ch_id: items.channel_id,
            model: modelVersion,
            inviter_id: inviterId,
            index: (page - 1) * 10 + (index + 1)
          }
        }
      ])
    } catch (err) {
      console.log(err)
    }
    // HACK: add ubt
    setTimeout(() => {
      window.location.href = `${link}&${getUbt}${model}`
    }, 100)
  }

  const changeMoney = () => {
    const cMoney = (items.lecture_money / 100).toFixed(2)
    if (!items.has_limitmoney && items.lecture_money === 0) {
      return (
        <p>
          <span style={{ color: '#FF3F3C', fontSize: 15, fontWeight: 500 }}>免费</span>
        </p>
      )
    }

    if (items.has_limitmoney && items.limit_money === 0) {
      return (
        <p>
          <span style={{ color: '#FF3F3C', fontSize: 15, fontWeight: 500 }}>限时免费</span>
        </p>
      )
    }

    if (items.has_limitmoney) {
      const lMoney = (items.limit_money / 100).toFixed(2)
      return (
        <>
          <div className={Styles.limitMoney}>
            <p>
              ¥{lMoney.split('.')[0]}
              <span>.{lMoney.split('.')[1]}</span>
            </p>
          </div>
          <div className={Styles.originmoney}>
            <del className={Styles.deleteMoney}>￥{(items.lecture_money / 100).toFixed(2)}</del>
          </div>
        </>
      )
    } else {
      return (
        <div className={Styles.limitMoney}>
          <p>
            ¥{cMoney.split('.')[0]}
            <span>.{cMoney.split('.')[1]}</span>
          </p>
        </div>
      )
    }
  }

  return (
    // ch_id: props.item.channel_id,
    // model: props.modelVersion,
    // inviter_id: 61221610,
    // spmElement: `${initSpm}.${RegisterElement.rec_list_x}`,
    // index: (props.page - 1) * 10 + (props.index + 1)
    <ViewingMonitor
      ubt={ubt}
      params={{
        ch_id: item.channel_id,
        model: modelVersion,
        content: '猜你喜欢',
        inviter_id: 61221610,
        index: (page - 1) * 10 + (index + 1)
      }}
    >
      <div className={[Styles.WrapItem, style.WrapItem].join(' ')} onClick={() => goUrl()}>
        <div className={style.liveroom}>
          <img className={style.photo} src={item.liveroom_avatar} alt="" />
          <div className={style.text}>{item.liveroom_name}</div>
        </div>
        <div className={style.WrapSubItem}>
          <div className={Styles.WrapItemLeft}>
            <ImageView url={items.cover_url} width={300} />
          </div>
          <div className={Styles.WrapItemRight}>
            <div className={Styles.rightTop}>
              <div className={classes(Styles.titleArea, 'TextChangeToTwoLines')}>
                {items.is_preffered && (
                  <div className={Styles.tags}>
                    <img src="https://static-cos.lycheer.net/picture/10490565_2851c8d7884e28dd13a5119f3f0afe89.jpg" alt="" />
                  </div>
                )}
                {items.name}
              </div>
            </div>
            <div className={Styles.rightMiddle}>
              <div className={Styles.moneyArea}>{changeMoney()}</div>
            </div>
            <div className={Styles.rightBottom}>
              <div className={Styles.rightBottomLeft}>
                <div className={Styles.expectedLectures} style={{ color: 'rgb(153, 153, 153)' }}>
                  已更新{items.updated_lectures}节
                </div>
                <div className={Styles.popularNum}>
                  <div>{item.popular > 1000 ? <>{renderPopular(item.popular)}人在看</> : <span>精选推荐</span>}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ViewingMonitor>
  )
}



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeRecommendModule/HomeRecommendModule.tsx